export default __webpack_public_path__ + "cb842ffd038fb0cd742dcc75938b4f26.png";